<template>
<div style="overflow: hidden; padding-top: 100px; padding-bottom: 250px" >
    
    <b-row class="m-0 justify-content-center">
      <div  style="width: 1700px; max-width: 90%">
           <div  class="d-lg-none showcase-invert bg-white shadow mx-2 mb-2 mt-5"  style="min-width: 95%" v-if="order">
          <div class="showcase-header py-4 linear-primary text-white" style="position: relative; cursor: pointer" @click="$router.push('/orders').catch(err => {})">
            <h4 class="text-center m-0">Bestellung vom: {{ order.created | moment('DD.MM.YYYY HH:mm')}}</h4>
          </div>

            <div v-if="order">
              <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Bestellnummer:</h5>
                <h5 class="m-0">{{order.ordernumber}}</h5>
              </b-row>
               <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Abhol-/Lieferzeit:</h5>
                <h5 class="m-0">{{order.delivery_time | moment('DD.MM.YYYY HH:mm')}}</h5>
              </b-row>
              <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Besteller:</h5>
                <h5 class="m-0">{{order.customer_firstname}} {{order.customer_lastname}}</h5>
              </b-row>
              <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Telefon:</h5>
                <h5 class="m-0">{{order.customer_phone}}</h5>
              </b-row>
              <b-row class="m-0 my-2 mb-4 justify-content-between" v-if="order.addressData">
                <h5 class="m-0" >Lieferadresse:</h5>
                <h5 class="m-0">{{order.addressData.locality}}</h5>
              </b-row>
              <div>
                <div class="my-2" v-for="item in order.items" :key="item.index">
                    <b-row class="m-0 justify-content-between" >
                      <h5 class="m-0">{{ item._id.title }}</h5>
                      <h5 class="m-0">x {{ item.amount }}</h5>
                    </b-row>
                    <b-row class="m-0 justify-content-between" v-if="item.note">
                      <p class="m-0">Hinweis: {{ item.note }}</p>
                    </b-row>
                    <b-row class="m-0 mt-1 justify-content-between" v-if="item.extras">
                      <div v-for="extra in item.extras" class="w-100" :key="extra.index">
                        <p v-if="extra.choosen" class="m-0">{{ extra.title }}</p>
                      </div>
                    </b-row>
                    <hr>
                  </div>
              </div>
              
              <b-row class="m-0 mt-3 justify-content-between">
                <h5 class="m-0">Rechnungsbetrag:</h5>
              <h5 class="m-0">{{getTotalPrice(order)}}</h5>
              </b-row>
              <b-row class="m-0 mt-3 justify-content-between">
                <b-button block variant="warning" v-if="order.status == 'bestellt'" @click="updateOrder('bestätigt')">Bestellung bestätigen</b-button>
                <b-button block variant="info" v-if="order.status == 'bestätigt'" @click="updateOrder('bereit')">Bestellung ist abholbereit</b-button>
                <b-button block variant="success" v-if="order.status == 'bereit'" @click="updateOrder('abgeholt')">Bestellung wurde abgeholt</b-button>
                <b-button block variant="success" disabled v-if="order.status == 'abgeholt'" >Bestellung ist abgeschlossen!</b-button>
              </b-row>
            </div>

        </div>
        <b-row class="m-0 justify-content-center" v-if="orders">
          <div  class="showcase-invert bg-white shadow m-2 mt-3"  style="min-width: 95%" >
          <div class="showcase-header py-4 linear-primary text-white" style="position: relative">
            <h4 class="text-center m-0">App-Bestellungen verwalten</h4>
          </div>
          <div v-if="orders.length > 0">
          <b-table @row-clicked="setOrder" borderless :fields="fields" :items="orders" striped responsive :per-page="10"
                :current-page="currentPageOrders">
        
            <template v-slot:head()="data">
              <p class="text-center text-dark" >{{ data.label.toUpperCase() }}</p>
            </template>

            <template v-slot:cell(created)="data">
              <p class="text-center my-2 text-dark" >{{data.item.created | moment('DD.MM.YYYY HH:mm')}}</p>
            </template>

            <template v-slot:cell(delivery_time)="data">
              <p class="text-center my-2 text-dark" >{{data.item.delivery_time | moment('DD.MM.YYYY HH:mm')}}</p>
            </template>

            <template v-slot:cell(customer_firstname)="data">
              <p class="text-center my-2 text-dark" >{{data.item.customer_firstname + ' ' + data.item.customer_lastname}}</p>
            </template>

            <template v-slot:cell(status)="data">
              <p class="text-center my-2 text-dark" ><b-badge :variant="getBadgeVariant(data.item.status)">{{data.item.status}}</b-badge></p>
            </template>

            <template v-slot:cell(payment_method)="data">
              <p class="text-center my-2 text-dark" >{{data.item.payment_method}}</p>
            </template>

            <template v-slot:cell(ordernumber)="data">
              <p class="text-center my-2 text-dark" >{{data.item.ordernumber}}</p>
            </template>

            <template v-slot:cell(price)="data">
              <p class="text-center my-2 text-dark" >{{ getTotalPrice(data.item) }}</p>
            </template>

             <template v-slot:cell(customer_verified)="data">
              <p class="m-0 text-center">
                <b-icon v-if="data.item.customer_verified" class="text-success h1 m-0 p-0" icon="check" aria-hidden="true"></b-icon>
                <b-icon v-if="data.item.customer_verified === false" class="text-danger h1 m-0 p-0" icon="x" aria-hidden="true"></b-icon>
              </p>
            </template>
          
          </b-table>
          <nav class="mt-4">
            <b-pagination size="sm" :total-rows="orders.length" :per-page="10" v-model="currentPageOrders" prev-text="letzte" next-text="nächste" hide-goto-end-buttons/>
          </nav>

          <div  class="d-none d-lg-block showcase-invert bg-white shadow mx-2 mb-2 mt-5"  style="min-width: 95%" v-if="order">
          <div class="showcase-header py-4 linear-primary text-white" style="position: relative; cursor: pointer" @click="$router.push('/orders').catch(err => {})">
            <h4 class="text-center m-0">Bestellung vom: {{ order.created | moment('DD.MM.YYYY HH:mm')}}</h4>
          </div>

            <div v-if="order">
              <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Bestellnummer:</h5>
                <h5 class="m-0">{{order.ordernumber}}</h5>
              </b-row>
               <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Abhol-/Lieferzeit:</h5>
                <h5 class="m-0">{{order.delivery_time | moment('DD.MM.YYYY HH:mm')}}</h5>
              </b-row>
              <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Besteller:</h5>
                <h5 class="m-0">{{order.customer_firstname}} {{order.customer_lastname}}</h5>
              </b-row>
              <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Telefon:</h5>
                <h5 class="m-0">{{order.customer_phone}}</h5>
              </b-row>
              <b-row class="m-0 my-2 mb-4 justify-content-between" v-if="order.addressData">
                <h5 class="m-0" >Lieferadresse:</h5>
                <h5 class="m-0">{{order.addressData.locality}}</h5>
              </b-row>
              <div>
                <div class="my-2" v-for="item in order.items" :key="item.index">
                    <b-row class="m-0 justify-content-between" >
                      <h5 class="m-0">{{ item._id.title }}</h5>
                      <h5 class="m-0">x {{ item.amount }}</h5>
                    </b-row>
                    <b-row class="m-0 justify-content-between" v-if="item.note">
                      <p class="m-0">Hinweis: {{ item.note }}</p>
                    </b-row>
                    <u><p class="m-0 mt-2">Beilagen / Extras:</p></u>
                    <b-row class="m-0  justify-content-between" v-if="item.extras">
                      <div v-for="extra in item.extras" class="w-100" :key="extra.index">
                        <p v-if="extra.choosen" class="m-0">{{ extra.title }}</p>
                      </div>
                    </b-row>
                    <u><p class="m-0 mt-2">Variante(n):</p></u>
                    <b-row class="m-0 mt-1 justify-content-between" v-if="item.variants">
                      <div v-for="variant in item.variants" class="w-100" :key="variant.index">
                        <p v-if="variant.choosen" class="m-0">{{ variant.choosen.title }}</p>
                      </div>
                    </b-row>
                    <hr>
                  </div>
              </div>

              
              
              <b-row class="m-0 mt-3 justify-content-between">
                <h5 class="m-0">Rechnungsbetrag:</h5>
              <h5 class="m-0">{{getTotalPrice(order)}}</h5>
              </b-row>
              <b-row class="m-0 mt-3 justify-content-between">
                <b-button block variant="warning" v-if="order.status == 'bestellt'" @click="updateOrder('bestätigt')">Bestellung bestätigen</b-button>
                <b-button block variant="info" v-if="order.status == 'bestätigt'" @click="updateOrder('bereit')">Bestellung ist abholbereit</b-button>
                <b-button block variant="success" v-if="order.status == 'bereit'" @click="updateOrder('abgeholt')">Bestellung wurde abgeholt</b-button>
                <b-button block variant="success" disabled v-if="order.status == 'abgeholt'" >Bestellung ist abgeschlossen!</b-button>
              </b-row>
            </div>

        </div>

          </div>
          <b-row class="m-0 my-3 justify-content-center" v-else>
            <div>
              <b-row class="m-0 my-3 justify-content-center">
                <b-img  :src="require(`@/assets/images/undraw_completed.svg`)" style="width: 200px; height: 200px" fluid alt="eatDorado Logo"></b-img>
              </b-row>
              <h3 class="text-center">Keine Bestellungen vorhanden</h3>
            </div>
          </b-row>
          </div>
        </b-row>
      </div>
    </b-row>
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
export default {
  name: 'Orders',
  mixins: [coreData],
  components: {

  }, 
  data: () => {
    return {
      currentPageOrders: 1,
      order: null,
      fields: [
        { key: 'created', label: 'Bestellzeit' },
        { key: 'delivery_time', label: 'Abhol-/Lieferzeit', sortable: true },
        { key: 'customer_firstname', label: 'Kunde', sortable: true },
        { key: 'price', label: 'Preis', sortable: true },
        { key: 'ordernumber', label: 'Bestellnummer', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'customer_verified', label: 'Bestätigt', sortable: true },
      ],
      departmentForm: {},
      newDepartment: false
    }
  },
  watch: {
    orders(){
       if(this.orders && !this.order){
        var query = this.orders.find(el => el._id == this.$route.query.id)
        if(query) return this.order = query
      }
    }
    
  },
  computed: {
    week(){
      if(this.kw){
        return {year: this.kw[0], week: this.kw[1], month: this.kw[2]}
      }
      return null
    },
  },
  mounted(){
    this.refreshData();
    this.$store.dispatch('tryAutoLogin')
    console.log(this.$route)
    if(this.orders && !this.order){
      var query = this.orders.find(el => el._id == this.$route.query.id)
      if(query) return this.order = query
    }
  },
  methods: {
    setOrder(record){
      this.order = record
    },
    updateOrder(status){
      const payload = {
        _id: this.order._id,
        data: {
          status: status
        }
      }
      this.order.status = status
      this.$store.dispatch('updateOrder', payload)
    },

    postDepartment(){
      var street = this.departmentForm.street
      var zipcode = this.departmentForm.zipcode
      var city = this.departmentForm.city
      var country = this.departmentForm.country
      var state = this.departmentForm.state

      if(!street){
        street = this.company.adress.street
      }

      if(!zipcode){
        zipcode = this.company.adress.zipcode
      }

      if(!city){
        city = this.company.adress.city
      }

      if(!country){
        country = this.company.adress.country._id
      }

      if(!state){
        state = this.company.adress.state._id
      }




      const payload = {
        company: this.company._id,
        title: this.departmentForm.title,
        adress: {
          street: street,
          zipcode: zipcode,
          city: city,
          country: country,
          state: state
        }
      }

      this.$store.dispatch('postDepartment', payload)
    }
  }
}
</script>

<style lang="scss" scoped>


</style>